module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery4_m.6fb3ae198c64d39917275010f31af818.png";